import client from '../../providers/fetchClient'

export const getExtract = id => client.get(`/v3/my-investments-extract?investor_id=${id}`)

export const exportExtract = (id, filter) =>
  client.get(`/v3/my-investments-extract?${filter}&investor_id=${id}`, {
    responseType: 'arraybuffer'
  })
